import React, { useEffect, useState } from 'react';

const CONSENT_KEY = 'analytics_consent_v1';

export default function Privacy(){
  const [consent, setConsent] = useState<string| null>(null);

  useEffect(()=>{
    try{ setConsent(localStorage.getItem(CONSENT_KEY)); }catch(e){ /* ignore */ }
  },[]);

  const revoke = () => {
    try{ localStorage.setItem(CONSENT_KEY, 'denied'); setConsent('denied'); }catch(e){ /* ignore */ }
    // optionally reload to ensure analytics unloaded on next load
  };

  const grant = () => {
    try{ localStorage.setItem(CONSENT_KEY, 'granted'); setConsent('granted'); }catch(e){ /* ignore */ }
  };

  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-2xl font-bold mb-4">إعدادات الخصوصية والتحليلات</h1>
      <p className="mb-6">هنا يمكنك إدارة موافقتك على أدوات التحليل والكوكيز.</p>

      <div className="mb-4">
        <strong>حالة الموافقة:</strong> <span className="mr-2">{consent ?? 'لم يتم الاختيار'}</span>
      </div>

      <div className="flex gap-4">
        <button onClick={grant} className="px-4 py-2 bg-primary text-white rounded">منح الموافقة</button>
        <button onClick={revoke} className="px-4 py-2 bg-gray-200 rounded">سحب الموافقة</button>
      </div>
    </div>
  );
}
